<main id="db-wrapper" class="bg-light">

  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>

  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">News Detail</h1>
              </div>
            </div>
          </div>
        </div>
        <app-form-spinner></app-form-spinner>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">News Detail</h1>
              </div>
            </div>
          </div>
        </div>
        <section class="py-7 py-lg-8" *ngIf="news!=null">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-12 mb-2">
                <div class="text-center mb-4">

                  <h1 class="display-3 fw-bold mb-4">
                    {{news.title}}
                  </h1>
                  <span class="mb-3 d-inline-block">
                    {{news.pubDate | date: 'dd MMM yyyy, h:mm a'}}
                  </span>
                </div>
                <!-- Media -->
                <div class="d-flex justify-content-between align-items-center mb-5">
                  <div class="d-flex align-items-center">
                    <img src="{{ getFaviconUrl(news.provider)}}" alt="avatar" class="rounded-circle avatar-md" />
                    <div class="ms-2 lh-1">
                      <h5 class="mb-1">{{ getSiteName(news.provider)}}</h5>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <!-- Image -->
              <div class="col-xl-10 col-lg-10 col-md-12 col-12 mb-6">
                <img src="{{news.mediaUrl}}" *ngIf="news.mediaUrl!=null" class="img-fluid rounded-3 w-100" />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-8 col-md-12 col-12 mb-2">
                <div>
                  <div class="mb-4">
                   
                    <div class="lead text-dark" [innerHTML]="sanitizeHtmlWithImageFix(news.description).sanitizedHtml"></div>

                    <img *ngIf="sanitizeHtmlWithImageFix(news.description).imageSrc" 
                        [src]="sanitizeHtmlWithImageFix(news.description).imageSrc" 
                        class="img-fluid rounded-2 shadow-sm my-3"
                        style="max-width: 100%; height: auto; object-fit: cover;" />

                  </div>
                  <div class="h5">
                    Lien de la source d'actualité : <a href="{{news.link}}" target="_blank"> {{news.link}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>
    </div>
    </div>
  </section>
</main>
<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
